import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { Frame } from '@/components';
import { jsx as _jsx } from "react/jsx-runtime";
const CompileError = ({
  error
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "ima-compile-error",
    children: error.frames.map(frame => /*#__PURE__*/_jsx(Frame, {
      frame: frame,
      type: error.type
    }, `${frame.fileName}${frame.line}${frame.column}`))
  });
};
export default CompileError;